import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef, useMemo, useLayoutEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import _, { max } from 'lodash';
import i18n from 'i18next';
import moment from 'moment';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as XLSX from 'xlsx';
import { useSelector } from 'react-redux';
import $ from 'jquery';
import { TablePagination } from '@material-ui/core';
import Progress from '../ui/react-ui/progress.jsx';
import DropDown from '../ui/react-ui/dropdown';
import DateRange from '../ui/react-ui/date-range';
import Tabs from '../ui/react-ui/tabs';
import DataTable from '../ui/table';
import SearchBar from '../ui/searchBar';
import DatePicker from '../ui/react-ui/date-picker'; // api

import { getAuditLogStatistics } from '../../api/settingAPI';
var t = i18n.getFixedT(null, 'audit-log-statistics');
var VIEW = Object.freeze({
  TABLE: 'table',
  CHART: 'chart'
});

var AuditLogStatisticsTable = function AuditLogStatisticsTable(props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  var id = props.id;
  var initDateTime = {
    from: moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm'),
    to: moment().format('YYYY-MM-DD HH:mm')
  };

  var _useState = useState(initDateTime),
      _useState2 = _slicedToArray(_useState, 2),
      dateTime = _useState2[0],
      setDateTime = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      moduleType = _useState4[0],
      setModuleType = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      targetType = _useState6[0],
      setTargetType = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      tableData = _useState8[0],
      setTableData = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      currentPage = _useState10[0],
      setCurrentPage = _useState10[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      totalCount = _useState12[0],
      setTotalCount = _useState12[1];

  var _useState13 = useState(10),
      _useState14 = _slicedToArray(_useState13, 2),
      rowsPerPage = _useState14[0],
      setRowsPerPage = _useState14[1];

  var _useState15 = useState({
    field: 'count',
    desc: true
  }),
      _useState16 = _slicedToArray(_useState15, 2),
      tableSort = _useState16[0],
      setTableSort = _useState16[1];

  var _useState17 = useState(''),
      _useState18 = _slicedToArray(_useState17, 2),
      keyword = _useState18[0],
      setKeyword = _useState18[1];

  var isMounted = useRef(false);

  var fetchData = function fetchData() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    console.log(dateTime);
    getAuditLogStatistics(contextRoot, false, moduleType, targetType, dateTime, keyword, tableSort, offset, rowsPerPage).then(function (result) {
      if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

      var newData = _.cloneDeep(result.content);

      _.map(newData, function (el, index) {
        el.sequence = offset + index + 1;
      });

      setTableData(newData);
    });
  };

  var handleChangeDateTime = function handleChangeDateTime(dateTime) {
    setDateTime(dateTime);
  };

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleExport = function handleExport() {
    var sortField = tableSort ? tableSort.field : 'count';
    var sortOrder = tableSort ? tableSort.desc ? 'desc' : 'asc' : 'asc';
    $.ajax({
      url: "".concat(contextRoot, "/audit-log-target-statistics/export"),
      method: 'GET',
      beforeSend: function beforeSend(xhr) {
        Progress.startSpin();
      },
      data: {
        targetType: targetType,
        moduleType: moduleType,
        start: dateTime.from + ':00',
        end: dateTime.to + ':59',
        sort: sortField + ':' + sortOrder,
        keyword: keyword
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function success(data) {
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = window.URL.createObjectURL(data);
        a.setAttribute('download', "audit-log-statistics-list.xlsx");
        a.click();
        document.body.appendChild(a);
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
        Progress.done();
      }
    });
  };

  useEffect(function () {
    if (!isMounted.current) return;
    fetchData();
  }, [keyword, JSON.stringify(tableSort), currentPage, rowsPerPage]);
  useEffect(function () {
    if (!isMounted.current) {
      fetchData(true);
      isMounted.current = true;
    }

    return function () {};
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'moduleType', {
    label: t('lbl-moduleType'),
    sortable: true,
    formatter: function formatter(val) {
      return t("lbl-".concat(val));
    }
  });

  _.set(fields, 'targetType', {
    label: t('lbl-targetType'),
    sortable: true,
    formatter: function formatter(val) {
      return t("lbl-".concat(val));
    }
  });

  _.set(fields, 'target', {
    label: t('lbl-target'),
    sortable: true
  });

  _.set(fields, 'count', {
    label: t('lbl-count'),
    sortable: true
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "auditLogStatistics-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "auditLogStatistics-headBar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-moduleType'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-moduleType-list'),
    list: [{
      value: 'APP',
      text: t('lbl-APP')
    }, {
      value: 'WEB',
      text: t('lbl-WEB')
    }, {
      value: 'MANAGE',
      text: t('lbl-MANAGE')
    }],
    value: moduleType,
    onChange: function onChange(value) {
      return setModuleType(value);
    },
    width: '200px'
  })), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-targetType'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-targetType-list'),
    list: [{
      value: 'HOME_TERMINAL',
      text: t('lbl-HOME_TERMINAL')
    }, {
      value: 'MAP_GATE',
      text: t('lbl-MAP_GATE')
    }, {
      value: 'MAP_TERMINAL',
      text: t('lbl-MAP_TERMINAL')
    }, {
      value: 'MAP_CAMERA',
      text: t('lbl-MAP_CAMERA')
    }, {
      value: 'MAP_VD',
      text: t('lbl-MAP_VD')
    }],
    value: targetType,
    onChange: function onChange(value) {
      return setTargetType(value);
    },
    width: '200px'
  })), /*#__PURE__*/React.createElement(DateRange, {
    id: "auditLogStatistics-datetime",
    enableTime: true,
    enableStartEndLabel: true,
    startLabel: t('lbl-start-time'),
    endLabel: t('lbl-end-time'),
    onChange: handleChangeDateTime,
    value: dateTime,
    limitRange: '30d'
  }), /*#__PURE__*/React.createElement(SearchBar // searchIconPosition='right'
  , {
    placeholder: "Search",
    onSearch: function onSearch(search) {
      setKeyword(search);
      fetchData();
    }
  }), /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: handleExport
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-download",
    title: t('lbl-auditLogStatistics-export')
  }))), /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-audit-log-statistics'))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: tableSort,
    onSort: function onSort(sort) {
      return setTableSort(sort);
    }
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })));
};

AuditLogStatisticsTable.defaultProps = {
  id: 'g-auditLog-statistics'
};
AuditLogStatisticsTable.PropTypes = {
  id: PropTypes.string
}; // ----------------------------------------------------------

var AuditLogStatisticsChart = function AuditLogStatisticsChart(props) {
  var _useSelector2 = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector2.envCfg.contextRoot;

  var _useState19 = useState(moment().format('YYYY-MM-DD')),
      _useState20 = _slicedToArray(_useState19, 2),
      date = _useState20[0],
      setDate = _useState20[1];

  var _useState21 = useState([]),
      _useState22 = _slicedToArray(_useState21, 2),
      exportData = _useState22[0],
      setExportData = _useState22[1];

  var chartRef = useRef(null);
  var monthRanges = useMemo(function () {
    // 取得過去12個月的時間區段，每個用from和to來表示
    var ranges = [];

    for (var i = 0; i < 12; i++) {
      var from = moment(date).subtract(i, 'months').startOf('month').toDate();
      var to = moment(date).subtract(i, 'months').endOf('month').toDate();
      ranges.push({
        from: from,
        to: to
      });
    }

    return ranges.reverse(); // 反轉順序，從最新的月份開始
  }, [date]);

  var handleChangeDatePicker = function handleChangeDatePicker(range) {
    if (!range) {
      return;
    }

    setDate(range);
  };

  var handleExport = function handleExport() {
    var rows = [[t('lbl-audit-log-statistics-chart-export-label-month')], [t('lbl-audit-log-statistics-chart-export-label-front-stage')], [t('lbl-audit-log-statistics-chart-export-label-back-stage')], [t('lbl-audit-log-statistics-chart-export-label-app')]];
    exportData.forEach(function (item) {
      if (item.date) {
        rows[0].push(item.date);
      }

      if (item.frontStage >= 0) {
        rows[1].push(item.frontStage);
      }

      if (item.backStage >= 0) {
        rows[2].push(item.backStage);
      }

      if (item.app >= 0) {
        rows[3].push(item.app);
      }
    });
    var ws = XLSX.utils.aoa_to_sheet(rows);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'AuditLogStatistics');
    XLSX.writeFile(wb, "audit_log_statistics-".concat(exportData[0].date, "-").concat(exportData[exportData.length - 1].date, ".xlsx"));
  };

  var initChart = function initChart() {
    var chart = am4core.create('g-auditLog-statistics-chart', am4charts.XYChart);
    chart.hiddenState.properties.opacity = 0; // 根據月份範圍來設定圖表的資料

    var dataAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    dataAxis.dataFields.category = 'date';
    dataAxis.renderer.grid.template.location = 0;
    dataAxis.renderer.minGridDistance = 50;
    dataAxis.renderer.labels.template.rotation = -45;
    dataAxis.renderer.labels.template.horizontalCenter = 'right';
    dataAxis.renderer.labels.template.verticalCenter = 'middle';
    dataAxis.title.text = t('lbl-audit-log-statistics-chart-month');
    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = t('lbl-audit-log-statistics-chart-count');
    valueAxis.min = 0;
    valueAxis.numberFormatter = new am4core.NumberFormatter();
    valueAxis.numberFormatter.numberFormat = '#';
    var series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.categoryX = 'date';
    series.dataFields.valueY = 'value';
    series.tooltipText = '{valueY.value}';
    series.strokeWidth = 2;
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = 'none';
    chartRef.current = chart;
  };

  var fetchData = function fetchData() {
    // 取得當前月份往前12個月的資料
    if (monthRanges.length === 0) {
      return;
    }

    var getDataPromises = monthRanges.map(function (range) {
      return getAuditLogStatistics(contextRoot, false, '', '', {
        from: moment(range.from).format('YYYY-MM-DD HH:mm'),
        to: moment(range.to).format('YYYY-MM-DD HH:mm')
      }, '', {
        field: 'count',
        desc: true
      });
    });
    Promise.all(getDataPromises).then(function (results) {
      var newChartData = [];
      var newExportData = [];
      results.forEach(function (result, index) {
        // get from year and month
        newChartData.push({
          date: moment(monthRanges[index].from).format('YYYY/MM'),
          value: (result.content || []).reduce(function (sum, item) {
            return sum + (item.count || 0);
          }, 0)
        });
        newExportData.push({
          date: moment(monthRanges[index].from).format('YYYY/MM'),
          frontStage: (result.content || []).reduce(function (sum, item) {
            if (item.moduleType === 'WEB') {
              return sum + (item.count || 0);
            }

            return sum;
          }, 0),
          backStage: (result.content || []).reduce(function (sum, item) {
            if (item.moduleType === 'MANAGE') {
              return sum + (item.count || 0);
            }

            return sum;
          }, 0),
          app: (result.content || []).reduce(function (sum, item) {
            if (item.moduleType === 'APP') {
              return sum + (item.count || 0);
            }

            return sum;
          }, 0)
        });
      });
      setExportData(newExportData);

      if (chartRef.current) {
        chartRef.current.data = newChartData;
      }
    });
  };

  useLayoutEffect(function () {
    initChart();
    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chartRef.current && chartRef.current.dispose();
    };
  }, []);
  useEffect(function () {
    fetchData();
  }, [monthRanges]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "auditLogStatistics-headBar"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "datetime",
    className: "date-range-label",
    style: {
      margin: '0px 5px'
    }
  }, t('lbl-end-month')), /*#__PURE__*/React.createElement(DatePicker, {
    id: "datetime",
    onChange: function onChange(val) {
      return handleChangeDatePicker(val);
    },
    enableTime: false,
    value: date,
    onlyYearMonth: true
  }), /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: handleExport
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-download",
    title: t('lbl-auditLogStatistics-export')
  }))), /*#__PURE__*/React.createElement("div", {
    id: props.id,
    style: {
      flex: 1
    }
  }));
};

AuditLogStatisticsChart.defaultProps = {
  id: 'g-auditLog-statistics-chart'
};
AuditLogStatisticsChart.propTypes = {
  id: PropTypes.string.isRequired
}; // ----------------------------------------------------------

var AuditLogStatistics = function AuditLogStatistics(props) {
  var id = props.id;

  var _useState23 = useState(VIEW.TABLE),
      _useState24 = _slicedToArray(_useState23, 2),
      currentTab = _useState24[0],
      setCurrentTab = _useState24[1];

  var tabsMenu = useMemo(function () {
    return [{
      key: VIEW.TABLE,
      title: t('lbl-tab-table')
    }, {
      key: VIEW.CHART,
      title: t('lbl-tab-chart')
    }];
  }, []); // redux

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement(Tabs, {
    id: "g-logistic-statistics-tabs",
    menu: tabsMenu,
    current: currentTab,
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, currentTab === VIEW.TABLE && /*#__PURE__*/React.createElement(AuditLogStatisticsTable, null), currentTab === VIEW.CHART && /*#__PURE__*/React.createElement(AuditLogStatisticsChart, null)));
};

AuditLogStatistics.defaultProps = {
  id: 'g-auditLog-statistics'
};
AuditLogStatistics.propTypes = {
  id: PropTypes.string.isRequired
};
export default AuditLogStatistics;